import {EventEmitter, Output} from "@angular/core";

/**
 * Created by Benoit Valkenberg on 03-12-17.
 */
export class TripsNavbarComponent{

    @Output() sidebarButtonClicked:EventEmitter<any> = new EventEmitter<any>();

    public sideBarButtonIsClicked(){
        this.sidebarButtonClicked.emit();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/trips/navbar/navbar/navbar.ts